import { isDesktop } from './device';
import amaLog from '../helpers/log';
import { resolveCountryCode } from './domain';

export const seenthis = (adUnitPath: string, domId: string) => {
  window.highImpactJs = window.highImpactJs || {
    cmd: [],
  };

  const sizes = isDesktop() ? [[1920, 1080]] : [[1080, 1920]];

  const addMidScrollScript = () => {
    window.highImpactJs.cmd.push(() => {
      window.highImpactJs.defineSlot({
        slot: adUnitPath,
        template: 'midscroll',
        sizes: sizes,
        adUnitId: domId,
        waitForAdSignal: true,
      });
    });
  };
  const isTopAds = domId.includes('top_ad');
  if (isTopAds) {
    window.highImpactJs.cmd.push(() => {
      window.highImpactJs.setConfig({
        topBarHeight: isDesktop() ? 0 : 60,
        plugins: ['gam'],
        zIndex: 199,
      });

      window.highImpactJs.setTemplateConfig('topscroll', {
        peekAmount: '70vh',
        adLabel: {
          content: resolveCountryCode() === 'dk' ? "Annonce" : "Annons",
          css: "position: absolute;display: flex;justify-content: space-between;height: 36px;width: 100%;line-height: 36px;background-color: white;z-index: 200;text-align: center;cursor: pointer;font-size: 0.75rem;font-family: 'Helvetica';color: #8d8d8d;padding-left:10px;",
        }
      });

      window.highImpactJs.defineSlot({
        slot: adUnitPath,
        template: 'topscroll',
        sizes: sizes,
        adUnitId: domId,
        waitForAdSignal: true,
      });
    });

    addSeenthisStyle();
  } else {
    addMidScrollScript();
  }
  topMidscrollerHandling(domId);
};

const addSeenthisStyle = () => {

  const dkStyles = resolveCountryCode() === 'dk' ? `
    body.high-impact-topscroll-rendered {
      padding-top: calc(70vh);
    }

    body.high-impact-topscroll-rendered [data-type="ad"]:has(.high-impact-ad-wrapper-topscroll) {
      position: absolute;
      top: calc(-70vh - 90px);
      left: 0;
    }

    body.high-impact-topscroll-rendered #slug {
      padding-top: 0;
    }

    body.high-impact-topscroll-rendered #slug::before {
      content: "";
      display: block;
      height: 20px;
      width: 100%;
      background-color: white;
      position: relative;
      z-index: 6;
    }

    body.high-impact-topscroll-rendered .flex.justify-center {
      position: relative;
    }
  ` : '';

  const seenthisStyle = document.createElement('style');
  seenthisStyle.textContent = `
        body.high-impact-topscroll-rendered #__next {
          position: relative !important;
        }
        body.high-impact-topscroll-rendered:not(.high-impact-topscroll-is-hidden) #top-nav {
          position: absolute;
          max-height: unset !important;
        }
        ${dkStyles}
      `;
  document.head.appendChild(seenthisStyle);
};

const observers: { [key: string]: MutationObserver[] } = {};

const topMidscrollerHandling = (domId: string) => {
  const uniqueId = domId.split('-')[1] || 'default';
  const targetDiv = document.getElementById(domId) as HTMLElement;

  if (!targetDiv) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (
          targetDiv.classList.contains('high-impact-ad-wrapper-midscroll') ||
          targetDiv.classList.contains('high-impact-ad-wrapper-topscroll')
        ) {
          amaLog('SeenthisScroller - Found div class', uniqueId);

          waitForJWWrappers().then((jwWrappers) => {
            if (jwWrappers.length > 0) {
              initTopMidscrollerVideoHide(targetDiv, jwWrappers);
            } else {
              amaLog('No jw-wrapper elements found after timeout');
            }
          });

          observer.disconnect();
          // Assume that all bids are made for uniqueId and midscrollers placements are defined in markup
          setTimeout(() => {
            amaLog(`SeenthisMidscroller - MutationObserver.disconnect() for ${uniqueId}`);
            observers[uniqueId]?.forEach((observer) => observer.disconnect());
          }, 2000);
        }
      }
    });
  });
  observer.observe(targetDiv, { attributes: true, attributeFilter: ['class'] });

  if (!observers[uniqueId]) {
    observers[uniqueId] = [];
  }
  observers[uniqueId].push(observer);
  setTimeout(() => {
    observer.disconnect();
  }, 10000); // Cleanup if no midscroller ad is found
};
const waitForJWWrappers = (timeoutMs = 10000): Promise<HTMLElement[]> => {
  return new Promise((resolve) => {
    const findElements = () =>
      Array.from(document.querySelectorAll('.jw-wrapper')).filter((el) => el instanceof HTMLElement) as HTMLElement[];

    const existingElements = findElements();
    if (existingElements.length > 0) {
      amaLog('waitForJWWrappers - Found immediately');
      return resolve(existingElements);
    }

    const observer = new MutationObserver((_mutations, obs) => {
      const found = findElements();
      if (found.length > 0) {
        amaLog('waitForJWWrappers - Found via MutationObserver');
        obs.disconnect();
        resolve(found);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Fallback timeout
    setTimeout(() => {
      observer.disconnect();
      amaLog('waitForJWWrappers - Timeout waiting for jw-wrapper elements');
      resolve([]);
    }, timeoutMs);
  });
};

const initTopMidscrollerVideoHide = (adUnitDiv: HTMLElement, jwWrappers: HTMLElement[]) => {
  amaLog('SeenthisMidscroller - Video hiding for ', jwWrappers);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        jwWrappers.forEach((el: HTMLElement) => {
          el.style.opacity = entry.isIntersecting ? '0' : '1';
        });
      });
    },
    { threshold: 0 },
  );

  jwWrappers.forEach((el: HTMLElement) => {
    el.style.setProperty('transition', 'opacity 0.5s ease 0s', 'important');
  });

  observer.observe(adUnitDiv);
};
